import React, { useEffect, useState } from "react";
import ApiDataBase from "server";
import UseContext from "hooks/useContext";
import SectionWrapper, {
    FormField,
    inputClassName,
} from "pages/createMission/components/SectionWrapper";
import MonoSelect from "components/componentsForm/monoSelect";

const QUALIFICATION_TYPES = {
    sale: { name: "Vente", icon: "🛍" },
    food: { name: "Restauration", icon: "🍳" },
    logistic: { name: "Logistique", icon: "📦" },
    administration: { name: "Administration", icon: "🧾" },
    largeDistribution: { name: "Grande distribution", icon: "🛒" },
    industry: { name: "Industrie", icon: "🏭" },
    other: { name: "Autre", icon: "👷" },
};

const ActivityTemplate = () => {
    const { templateData, setTemplateData } = UseContext();
    const [typesQualifications, setTypesQualifications] = useState([]);
    const [isWaitingTypes, setIsWaitingTypes] = useState(true);
    const [listQualifications, setListQualifications] = useState([]);
    const [hasTouchedName, setHasTouchedName] = useState(
        !!templateData.name && templateData.name !== templateData.qualification
    );

    const selectedType = Object.keys(QUALIFICATION_TYPES).find(
        (key) => QUALIFICATION_TYPES[key].name === templateData.activity
    );

    const filteredQualifications = selectedType
        ? listQualifications.filter((q) => q.type === selectedType)
        : [];

    useEffect(() => {
        ApiDataBase.getListQualifications(
            {},
            (res) => setListQualifications(res),
            (err) => console.warn(err)
        );
    }, []);

    useEffect(() => {
        setIsWaitingTypes(true);
        ApiDataBase.getTypesQualifications(
            {},
            (res) => {
                setTypesQualifications(res);
                setIsWaitingTypes(false);
            },
            (err) => {
                console.warn(err);
                setIsWaitingTypes(false);
            }
        );
    }, []);

    const handleTypeClick = (type) => {
        setTemplateData((prev) => ({
            ...prev,
            activity:
                selectedType === type ? "" : QUALIFICATION_TYPES[type].name,
            qualification: selectedType === type ? "" : prev.qualification,
        }));
    };

    const handleQualificationChoice = (selected) => {
        const value = selected ? selected.value : "";
        setTemplateData((prev) => ({
            ...prev,
            qualification: value,
            name: hasTouchedName ? prev.name : value,
        }));
    };

    const handleNameChange = (e) => {
        setHasTouchedName(true);
        setTemplateData((prev) => ({ ...prev, name: e.target.value }));
    };

    return (
        <div className={"flex flex-col gap-6"}>
            <SectionWrapper
                title="Secteur d'activité"
                description="Sélectionnez le secteur d'activité et la qualification recherchée pour cette fiche de poste."
            >
                <FormField label="Secteur">
                    <div className={"grid grid-cols-3 gap-4"}>
                        {isWaitingTypes
                            ? [1, 2, 3, 4, 5].map((i) => (
                                  <div
                                      key={i}
                                      className={
                                          "h-24 flex flex-col justify-center items-center gap-2 border rounded-lg"
                                      }
                                  >
                                      <div className={"h-8 bg-gray-200 rounded w-8"} />
                                      <div className={"h-3 bg-gray-200 rounded w-20"} />
                                  </div>
                              ))
                            : typesQualifications.map(
                                  (type) =>
                                      QUALIFICATION_TYPES[type] && (
                                          <div
                                              key={type}
                                              className={`h-24 flex flex-col justify-center items-center gap-2 border rounded-lg cursor-pointer ${
                                                  selectedType === type
                                                      ? "border-yellow-500 bg-yellow-50"
                                                      : "border-gray-200"
                                              }`}
                                              onClick={() => handleTypeClick(type)}
                                          >
                                              <div className={"text-2xl"}>
                                                  {QUALIFICATION_TYPES[type].icon}
                                              </div>
                                              <div className={"ft-sm"}>
                                                  {QUALIFICATION_TYPES[type].name}
                                              </div>
                                          </div>
                                      )
                              )}
                    </div>
                </FormField>
                <FormField label="Qualification">
                    <MonoSelect
                        data={filteredQualifications}
                        selectArray={handleQualificationChoice}
                        defaultValue={templateData.qualification}
                    />
                </FormField>
            </SectionWrapper>
            <SectionWrapper
                title="Nom du modèle"
                description="Pré-rempli avec la qualification choisie. Modifiez-le pour mieux retrouver votre fiche."
            >
                <FormField label="Nom">
                    <input
                        type="text"
                        className={inputClassName}
                        value={templateData.name}
                        onChange={handleNameChange}
                        placeholder="Ex: Vendeur boutique centre-ville"
                    />
                </FormField>
            </SectionWrapper>
        </div>
    );
};

export default ActivityTemplate;
